import Hero from './components/Hero';
import BottomImage from './components/BottomImage';
import LeftImage from './components/LeftImage';
import RightImage from './components/RightImage';
import ThreeColumns from './components/ThreeColumns';
import About from './components/About';

const componentMap = {
  hero: Hero,
  bottom_image: BottomImage,
  left_image: LeftImage,
  right_image: RightImage,
  three_columns: ThreeColumns,
  about: About,
};

export default componentMap;